<template>
  <v-container fluid class="background py-10">
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="specialities_title my-3">
            {{ specialities.title }}
          </div>
        </v-col>
        <v-col
          v-for="spec in specialities.list"
          :key="spec.title"
          md="4"
          sm="12"
          cols="12"
        >
          <div class="specialities_title my-3 d-flex">
            <v-img
              alt="Local image"
              class="shrink my-auto mr-3"
              contain
              :src="require('../../assets/' + spec.icon)"
              width="35px"
              height="41px"
            />
            <div class="my-auto">
              {{ spec.title }}
            </div>
          </div>
          <div class="specialities_text my-2">
            <div class="mb-5" v-html="spec.description" />
            <ul v-for="detail in spec.detail" :key="detail">
              <li>{{ detail }}</li>
            </ul>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import lang from "../../lang/pt.json";

export default {
  name: "About",

  data: () => ({
    specialities: lang.home.specialities,
  }),
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.background {
  background-color: white;
}

.specialities_title {
  color: map-get($theme-colors, "dark-blue");
  font-family: nexa_bold;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 24px;
}

.specialities_text {
  color: map-get($theme-colors, "dark-blue");
  font-family: "Roboto" !important;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
}
</style>
